<template>
  <div class="transport-modes-profile">
    <CustomHeader
      :title="title"
      :fectchPastTime="fectchPastTime"
      :fectchRealTime="fectchRealTime"
      :searchInputHeader="searchInputHeader"
      :generatePDF="generatePDF"
    />
    <div class="content">
      <div v-if="isGenderChartEnabled" class="profile-container-gender-chart no-print page-print">
        <span class="profile-gender-chart-title">Gênero</span>
        <CustomSkeleton v-if="isLoadingAllData" type="card" />
        <div>
          <div class="profile-gender-chart-content-percent">
            <span class="profile-gender-chart-subtitle">{{ mostFrequentGenderPercentage }}%</span>
          </div>
          <span class="profile-gender-chart-content"
            >dos visitantes se identifica como
            {{ mostFrequentGender.charAt(0).toUpperCase() + mostFrequentGender.slice(1) }}.</span
          >
          <canvas id="profile-gender-chart" class="profile-gender-chart" />
        </div>
      </div>
      <div class="content-column">
        <div v-if="isStayChartEnabled" class="profile-container-time-chart page-print">
          <span class="profile-title">Tempo médio de estadia</span>
          <CustomSkeleton v-if="isLoadingAllData" type="list" />
          <canvas id="profile-time-chart" class="profile-time-chart" />
        </div>
        <div
          v-if="isAccommodationChartEnabled"
          class="profile-container-accommodation-preference-chart page-print"
        >
          <span class="profile-title">Preferência das acomodações </span>
          <CustomSkeleton v-if="isLoadingAllData" type="list" />
          <canvas
            id="profile-accommodation-preference-chart"
            class="profile-accommodation-preference-chart"
          />
        </div>
      </div>
    </div>

    <div v-if="isOriginChartEnabled" class="profile-container-map page-print">
      <span class="profile-title">Origem</span>
      <span class="profile-subtitle">{{
        mostFrequentState.charAt(0).toUpperCase() + mostFrequentState.slice(1)
      }}</span>
      <span class="profile-content">É a origem mais comum de turistas em Foz do Iguaçu.</span>
      <div id="profile-origin-map" class="profile-map" />
    </div>
    <div class="content-second">
      <div v-if="isAgeEnabled" class="profile-container-age-chart page-print">
        <span class="profile-title">Idade média </span>
        <CustomSkeleton v-if="isLoadingAllData" type="card" />
        <canvas id="profile-age-chart" class="profile-age-chart" />
      </div>
      <div
        v-if="isTransportChartEnabled"
        class="profile-container-transport-preference-chart page-print"
      >
        <span class="profile-transport-preference-chart-title">Preferência de modal</span>
        <CustomSkeleton v-if="isLoadingAllData" type="card" />
        <div>
          <div class="profile-transport-preference-chart-content-percent">
            <span class="profile-transport-preference-chart-subtitle"
              >{{ mostFrequentTransportModePercentage }}%</span
            >
          </div>
          <span class="profile-transport-preference-chart-content"
            >dos visitantes chegam ao município de
            {{
              mostFrequentTransportMode.charAt(0).toUpperCase() + mostFrequentTransportMode.slice(1)
            }}</span
          >
          <canvas
            id="profile-transport-preference-chart"
            class="profile-transport-preference-chart"
          />
        </div>
      </div>
    </div>

    <div v-if="isFavoriteAttractionsEnabled" class="profile-container-map no-print page-print">
      <span class="profile-title">Atrações Favoritas</span>
      <div id="profile-favorite-attractions-map" class="profile-map" />
    </div>
    <Toast />
    <ProfileInsights
      v-if="genderCounts && mostFrequentGender"
      :gender-counts="genderCounts"
      :stay-counts="stayCounts"
      :accommodation-counts="accommodationCounts"
      :transport-mode-counts="transportModeCounts"
      :origin-counts="originCounts"
      :transport-mode-preferences-question-counts="transportModePreferencesQuestionCounts"
      :age-counts="ageCounts"
      :most-frequent-state="mostFrequentState"
      :most-frequent-transport-mode="mostFrequentTransportMode"
      :most-frequent-gender="mostFrequentGender"
      :most-frequent-gender-percentage="mostFrequentGenderPercentage"
      :most-frequent-transport-mode-percentage="mostFrequentTransportModePercentage"
      :gender-questions-data="genderQuestionsData"
      :average-length-of-stay-questions-data="averageLengthOfStayQuestionsData"
      :accommodation-preferences-question-data="accommodationPreferencesQuestionData"
      :state-origin-question-data="stateOriginQuestionData"
      :transport-mode-preferences-question-data="transportModePreferencesQuestionData"
      :favorite-attractions-data="favoriteAttractionsData"
      :age-range-question-data="ageRangeQuestionData"
      :roleIdProp="roleId"
    />

    <vue-html2pdf
      ref="html2Pdf"
      :showLayout="false"
      :floatLayout="true"
      :enableDownload="true"
      :previewModal="false"
      :pdfQuality="2"
      :manualPagination="true"
      pdfFormat="a4"
      pdfOrientation="landscape"
      pdfContentWidth="1100px"
      filename="SmartDestination - Sistema preditivo de Modais"
    >
      <section slot="pdf-content" class="pdf-content">
        <br />

        <h1 style="text-align: center; font-weight: 700; margin-top: 10px">
          SmartDestination - Sistema preditivo de Modais
        </h1>
        <h3 style="text-align: center; font-weight: 700; margin-top: 10px">Perfil do Visitante</h3>
        <h3 style="text-align: center; font-weight: 500; margin-top: 20px">
          Gerado em {{ customFormatter(new Date()) }}
        </h3>

        <br />
      </section>
      <section v-if="printGender" slot="pdf-content" class="pdf-content">
        <table class="report-table">
          <tr>
            <th>Gênero</th>
            <th>Quantidade</th>
          </tr>
          <tr v-for="(count, gender) in genderCounts" :key="gender">
            <td>{{ gender }}</td>
            <td>{{ count }}</td>
          </tr>
        </table>
      </section>

      <section v-if="printStayChart" slot="pdf-content" class="pdf-content">
        <table class="report-table">
          <tr>
            <th>Tempo de Estadia</th>
            <th>Quantidade</th>
          </tr>
          <tr v-for="(count, stayCount) in stayCounts" :key="stayCount">
            <td>{{ stayCount }}</td>
            <td>{{ count }}</td>
          </tr>
        </table>
      </section>
      <div class="html2pdf__page-break" />

      <section v-if="printAccommodationChart" slot="pdf-content" class="pdf-content">
        <table class="report-table">
          <tr>
            <th>Tipo de Acomodação</th>
            <th>Quantidade</th>
          </tr>
          <tr v-for="(count, accommodationCount) in accommodationCounts" :key="accommodationCount">
            <td>{{ accommodationCount }}</td>
            <td>{{ count }}</td>
          </tr>
        </table>
      </section>

      <section v-if="printOriginChart" slot="pdf-content" class="pdf-content">
        <table class="report-table">
          <tr>
            <th>Local de Origem</th>
            <th>Quantidade</th>
          </tr>
          <tr v-for="(count, originCount) in originCounts" :key="originCount">
            <td>{{ originCount.charAt(0).toUpperCase() + originCount.slice(1) }}</td>
            <td>{{ count }}</td>
          </tr>
        </table>
      </section>
      <div class="html2pdf__page-break" />

      <section v-if="printAgeChart" slot="pdf-content" class="pdf-content">
        <table class="report-table">
          <tr>
            <th>Idade Média</th>
            <th>Quantidade</th>
          </tr>
          <tr v-for="(count, ageCount) in ageCounts" :key="ageCount">
            <td>{{ ageCount }}</td>
            <td>{{ count }}</td>
          </tr>
        </table>
      </section>

      <section v-if="printTransportChart" slot="pdf-content" class="pdf-content">
        <table class="report-table">
          <tr>
            <th>Modal de Transporte</th>
            <th>Quantidade</th>
          </tr>
          <tr v-for="(count, transportModeCount) in transportModeCounts" :key="transportModeCount">
            <td>{{ transportModeCount }}</td>
            <td>{{ count }}</td>
          </tr>
        </table>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script setup>
import L from 'leaflet'
import _ from 'lodash'
import 'leaflet/dist/leaflet.css'
import 'leaflet.heat/dist/leaflet-heat.js'
import { Chart, registerables } from 'chart.js'
import axios from 'axios'
import Toast from 'primevue/toast'
import 'leaflet/dist/leaflet.css'
import CustomSkeleton from '@/Shared/CustomSkeleton'
import Layout from '../Layout.vue'
import ProfileInsights from './Insights/ProfileInsights.vue'
import CustomHeader from '../CustomHeader/CustomHeader.vue'
import { stateCoordinates, favoriteAttractionFozDoIguacuCoordinates } from '../../../Helpers/map'
import { useTransportModes } from '../../../stores/transportModes'
import { mapState } from 'pinia'
import moment from 'moment'
import VueHtml2pdf from 'vue-html2pdf'

Chart.register(...registerables)
export default {
  name: 'Profile',
  components: {
    CustomHeader,
    Toast,
    VueHtml2pdf,
    ProfileInsights,
    CustomSkeleton,
  },
  layout: Layout,
  computed: {
    ...mapState(useTransportModes, ['components']),
    ...mapState(useTransportModes, ['getCurrentComponente']),
    ...mapState(useTransportModes, ['componentsForPrint']),
  },
  props: {
    roleId: Number,
  },
  data() {
    return {
      title: 'Perfil do Visitante',
      genderCounts: {},
      stayCounts: {},
      accommodationCounts: {},
      transportModeCounts: {},
      originCounts: {},
      transportModePreferencesQuestionCounts: {},
      ageCounts: {},
      mostFrequentState: '',
      mostFrequentTransportMode: '',
      mostFrequentGender: '',
      mostFrequentGenderPercentage: 0,
      mostFrequentTransportModePercentage: 0,
      isGenderChartEnabled: true,
      isStayChartEnabled: true,
      isAccommodationChartEnabled: true,
      isOriginChartEnabled: true,
      isTransportChartEnabled: true,
      isFavoriteAttractionsEnabled: true,
      printGender: true,
      printStayChart: true,
      printAccommodationChart: true,
      printOriginChart: true,
      printTransportChart: true,
      printFavoriteAttractions: true,
      printAgeChart: true,
      isAgeEnabled: true,
      genderQuestionsData: {},
      averageLengthOfStayQuestionsData: {},
      accommodationPreferencesQuestionData: {},
      stateOriginQuestionData: {},
      transportModePreferencesQuestionData: {},
      favoriteAttractionsData: [],
      ageRangeQuestionData: {},

      genderChart: null,
      timeChart: null,
      accommodationChart: null,
      transportChart: null,
      ageChart: null,
      originMap: null,
      favoriteAttractionsMap: null,

      questionnaires: [
        { name: 'genderQuestions', data: this.genderQuestions },
        { name: 'averageLengthOfStayQuestions', data: this.averageLengthOfStayQuestions },
        {
          name: 'accommodationPreferencesQuestion',
          data: this.accommodationPreferencesQuestion,
        },
        { name: 'stateOriginQuestion', data: this.stateOriginQuestion },
        {
          name: 'transportModePreferencesQuestion',
          data: this.transportModePreferencesQuestion,
        },
        { name: 'favoriteAttractions', data: this.favoriteAttractions },
        { name: 'ageRangeQuestion', data: this.ageRangeQuestion },
      ],
      searchInputMatchs: [],
      isLoadingAllData: false,
    }
  },
  watch: {
    searchInputMatchs: {
      deep: true,
      immediate: true,
      handler: _.debounce(function (n, o) {
        const components = n
        if (components.length) {
          setTimeout(() => {
            components.map((component) => {
              this.loadChartSettings(component)
              if (component === 'genderQuestions') {
                if (this.isGenderChartEnabled) {
                  this.processGenderData()
                  this.createProfileGenderChart()
                  this.findMostFrequentGender(this.genderQuestionsData.answers)
                }
              } else if (component === 'averageLengthOfStayQuestions') {
                if (this.isStayChartEnabled) {
                  this.processStayData()
                  this.createProfileTimeChart()
                }
              } else if (component === 'accommodationPreferencesQuestion') {
                if (this.isAccommodationChartEnabled) {
                  this.processAccommodationData()
                  this.createAccommodationChart()
                }
              } else if (component === 'stateOriginQuestion') {
                if (this.isOriginChartEnabled) {
                  this.createOriginMap()
                  this.findMostFrequentState(this.stateOriginQuestionData.answers)
                }
              } else if (component === 'transportModePreferencesQuestion') {
                if (this.isTransportChartEnabled) {
                  this.processTransportData()
                  this.createTransportPreferenceChart()
                  this.findMostFrequentTransportMode(
                    this.transportModePreferencesQuestionData.answers,
                  )
                }
              } else if (component === 'ageRangeQuestion') {
                if (this.isAgeEnabled) {
                  this.processAgeData()
                  this.createAgeChart()
                }
              } else if (component === 'favoriteAttractions') {
                if (this.isFavoriteAttractionsEnabled) {
                  this.createFavoriteAttractionsMap()
                }
              }
            }, 100)
          })
        }
      }),
    },
    getCurrentComponente: {
      deep: true,
      handler: _.debounce(function (n, o) {
        const currentComponent = n
        this.loadChartSettings(currentComponent.component)
        setTimeout(() => {
          if (currentComponent.component === 'genderQuestions') {
            if (this.isGenderChartEnabled) {
              this.processGenderData()
              this.createProfileGenderChart()
              this.findMostFrequentGender(this.genderQuestionsData.answers)
            }
          } else if (currentComponent.component === 'averageLengthOfStayQuestions') {
            if (this.isStayChartEnabled) {
              this.processStayData()
              this.createProfileTimeChart()
            }
          } else if (currentComponent.component === 'accommodationPreferencesQuestion') {
            if (this.isAccommodationChartEnabled) {
              this.processAccommodationData()
              this.createAccommodationChart()
            }
          } else if (currentComponent.component === 'stateOriginQuestion') {
            if (this.isOriginChartEnabled) {
              this.createOriginMap()
              this.findMostFrequentState(this.stateOriginQuestionData.answers)
            }
          } else if (currentComponent.component === 'transportModePreferencesQuestion') {
            if (this.isTransportChartEnabled) {
              this.processTransportData()
              this.createTransportPreferenceChart()
              this.findMostFrequentTransportMode(this.transportModePreferencesQuestionData.answers)
            }
          } else if (currentComponent.component === 'ageRangeQuestion') {
            if (this.isAgeEnabled) {
              this.processAgeData()
              this.createAgeChart()
            }
          } else if (currentComponent.component === 'favoriteAttractions') {
            if (this.isFavoriteAttractionsEnabled) {
              this.createFavoriteAttractionsMap()
            }
          }
        }, 100)
      }),
    },
    componentsForPrint: {
      deep: true,
      handler(n, _) {
        n.map((componentToPrint) => {
          Object.keys(componentToPrint).forEach((key) => {
            if (key === 'component' && componentToPrint[key] === 'genderQuestions') {
              this.printGender = componentToPrint['print']
            }
            if (key === 'component' && componentToPrint[key] === 'averageLengthOfStayQuestions') {
              this.printStayChart = componentToPrint['print']
            }
            if (
              key === 'component' &&
              componentToPrint[key] === 'accommodationPreferencesQuestion'
            ) {
              this.printAccommodationChart = componentToPrint['print']
            }
            if (key === 'component' && componentToPrint[key] === 'stateOriginQuestion') {
              this.printOriginChart = componentToPrint['print']
            }
            if (
              key === 'component' &&
              componentToPrint[key] === 'transportModePreferencesQuestion'
            ) {
              this.printTransportChart = componentToPrint['print']
            }
            if (key === 'component' && componentToPrint[key] === 'ageRangeQuestion') {
              this.printAgeChart = componentToPrint['print']
            }
            if (key === 'component' && componentToPrint[key] === 'favoriteAttractions') {
              this.printFavoriteAttractions = componentToPrint['print']
            }
          })
        })
      },
    },
  },

  mounted() {
    this.getAllData()
  },

  methods: {
    customFormatter(date) {
      moment.locale('pt-br')
      return moment(date).format('DD/MM/YYYY')
    },
    generatePDF() {
      this.$refs.html2Pdf.generatePdf()
    },
    async getAllData() {
      if (this.isLoadingAllData) return

      try {
        this.isLoadingAllData = true
        const response = await axios.get('/api/transport-modes/profile')
        this.genderQuestionsData = response.data.genderQuestions
        this.averageLengthOfStayQuestionsData = response.data.averageLengthOfStayQuestions
        this.accommodationPreferencesQuestionData = response.data.accommodationPreferencesQuestion
        this.stateOriginQuestionData = response.data.stateOriginQuestion
        this.transportModePreferencesQuestionData = response.data.transportModePreferencesQuestion
        this.favoriteAttractionsData = response.data.favoriteAttractions
        this.ageRangeQuestionData = response.data.ageRangeQuestion
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoadingAllData = false
        this.initializeObservers()
      }
    },

    initializeObservers() {
      const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
      }

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const targetId = entry.target.id
            switch (targetId) {
              case 'profile-gender-chart':
                if (this.isGenderChartEnabled) {
                  this.processGenderData()
                  this.createProfileGenderChart()
                  this.findMostFrequentGender(this.genderQuestionsData.answers)
                }
                break
              case 'profile-time-chart':
                if (this.isStayChartEnabled) {
                  this.processStayData()
                  this.createProfileTimeChart()
                }
                break
              case 'profile-accommodation-preference-chart':
                if (this.isAccommodationChartEnabled) {
                  this.processAccommodationData()
                  this.createAccommodationChart()
                }
                break
              case 'profile-origin-map':
                if (this.isOriginChartEnabled) {
                  this.createOriginMap()
                  this.processOrigintData()
                  this.findMostFrequentState(this.stateOriginQuestionData.answers)
                }
                break
              case 'profile-transport-preference-chart':
                if (this.isTransportChartEnabled) {
                  this.processTransportData()
                  this.createTransportPreferenceChart()
                  this.findMostFrequentTransportMode(
                    this.transportModePreferencesQuestionData.answers,
                  )
                }
                break
              case 'profile-age-chart':
                if (this.isAgeEnabled) {
                  this.processAgeData()
                  this.createAgeChart()
                }
                break
              case 'profile-favorite-attractions-map':
                if (this.isFavoriteAttractionsEnabled) {
                  this.createFavoriteAttractionsMap()
                }
                break
              default:
                break
            }
            observer.unobserve(entry.target)
          }
        })
      }, observerOptions)

      const targets = [
        'profile-gender-chart',
        'profile-time-chart',
        'profile-accommodation-preference-chart',
        'profile-origin-map',
        'profile-transport-preference-chart',
        'profile-age-chart',
        'profile-favorite-attractions-map',
      ]

      targets.forEach((target) => {
        const element = document.getElementById(target)
        if (element) {
          observer.observe(element)
        }
      })
    },

    searchInputHeader(event) {
      const searchString = event.target.value.toLowerCase()
      const matchedQuestionnaires = new Set()
      this.questionnaires.forEach((questionnaire) => {
        const data = questionnaire.data

        Object.keys(data).forEach((key) => {
          const question = data[key]
          if (question && key === 'answers') {
            question.forEach((answers) => {
              Object.keys(answers).forEach((answerKey) => {
                const answer = answers[answerKey]
                if (
                  answer &&
                  answerKey === 'answer_text' &&
                  answer.toLowerCase().includes(searchString)
                ) {
                  matchedQuestionnaires.add(questionnaire.name)
                }
              })
            })
          }
          if (
            question &&
            key === 'question_text' &&
            question.toLowerCase().includes(searchString)
          ) {
            matchedQuestionnaires.add(questionnaire.name)
          }
        })
      })

      this.searchInputMatchs = Array.from(matchedQuestionnaires)
    },
    loadChartSettings(currentComponent = '') {
      const transportModes = useTransportModes()
      const customHeaderComponents = transportModes.components.map((component) => ({
        id: component.id,
        field: component.field,
        component: component.component,
        enabled: component.enabled,
      }))

      const componentSettings = {
        genderQuestions: 'isGenderChartEnabled',
        averageLengthOfStayQuestions: 'isStayChartEnabled',
        accommodationPreferencesQuestion: 'isAccommodationChartEnabled',
        stateOriginQuestion: 'isOriginChartEnabled',
        transportModePreferencesQuestion: 'isTransportChartEnabled',
        ageRangeQuestion: 'isAgeEnabled',
        favoriteAttractions: 'isFavoriteAttractionsEnabled',
      }

      Object.keys(componentSettings).forEach((key) => {
        this[componentSettings[key]] = customHeaderComponents.some(
          (component) => component.component === key && component.enabled,
        )
      })
    },

    loadInitalChartSettings() {
      this.loadChartSettings()

      const chartSettings = [
        {
          flag: 'isGenderChartEnabled',
          process: this.processGenderData,
          create: this.createProfileGenderChart,
        },
        {
          flag: 'isStayChartEnabled',
          process: this.processStayData,
          create: this.createProfileTimeChart,
        },
        {
          flag: 'isAccommodationChartEnabled',
          process: this.processAccommodationData,
          create: this.createAccommodationChart,
        },
        {
          flag: 'isOriginChartEnabled',
          process: this.processOrigintData,
          create: this.createOriginMap,
        },
        {
          flag: 'isTransportChartEnabled',
          process: this.processTransportData,
          create: this.createTransportPreferenceChart,
        },
        { flag: 'isAgeEnabled', process: this.processAgeData, create: this.createAgeChart },
        {
          flag: 'isFavoriteAttractionsEnabled',
          process: () => {},
          create: this.createFavoriteAttractionsMap,
        },
      ]

      chartSettings.forEach((setting) => {
        if (this[setting.flag]) {
          setting.process()
          setting.create()
        }
      })
    },

    findMostFrequentGender(answers) {
      let genderCounts = {}
      answers.forEach((answer) => {
        const gender =
          answer.answer_text.charAt(0).toUpperCase() + answer.answer_text.slice(1).toLowerCase()
        genderCounts[gender] = (genderCounts[gender] || 0) + 1
      })

      let mostFrequentGender = ''
      let maxCount = 0
      let totalCount = 0
      Object.keys(genderCounts).forEach((gender) => {
        totalCount += genderCounts[gender]
        if (genderCounts[gender] > maxCount) {
          maxCount = genderCounts[gender]
          mostFrequentGender = gender
        }
      })

      this.mostFrequentGenderPercentage = ((maxCount / totalCount) * 100).toFixed(2)

      this.mostFrequentGender = mostFrequentGender
    },
    findMostFrequentTransportMode(answers) {
      let transportModeCounts = {}
      answers.forEach((answer) => {
        const transportMode =
          answer.answer_text.charAt(0).toUpperCase() + answer.answer_text.slice(1).toLowerCase()
        transportModeCounts[transportMode] = (transportModeCounts[transportMode] || 0) + 1
      })

      let mostFrequentTransportMode = ''
      let maxCount = 0
      let totalCount = 0
      Object.keys(transportModeCounts).forEach((mode) => {
        totalCount += transportModeCounts[mode]
        if (transportModeCounts[mode] > maxCount) {
          maxCount = transportModeCounts[mode]
          mostFrequentTransportMode = mode
        }
      })

      this.mostFrequentTransportModePercentage = ((maxCount / totalCount) * 100).toFixed(2)

      this.mostFrequentTransportMode = mostFrequentTransportMode
    },
    findMostFrequentState(answers) {
      let stateCounts = {}
      answers.forEach((answer) => {
        const state = answer.answer_text.toLowerCase()
        stateCounts[state] = (stateCounts[state] || 0) + 1
      })

      let mostFrequentState = ''
      let maxCount = 0
      Object.keys(stateCounts).forEach((state) => {
        if (stateCounts[state] > maxCount) {
          maxCount = stateCounts[state]
          mostFrequentState = state
        }
      })

      this.mostFrequentState = mostFrequentState
    },
    processTransportData() {
      this.transportModeCounts = {}
      this.transportModePreferencesQuestionData.answers.forEach((answer) => {
        const transportMode = answer.answer_text.toLowerCase()
        if (this.transportModeCounts[transportMode]) {
          this.transportModeCounts[transportMode]++
        } else {
          this.transportModeCounts[transportMode] = 1
        }
      })
    },
    processOrigintData() {
      this.originCounts = {}
      this.stateOriginQuestionData.answers.forEach((answer) => {
        const origin = answer.answer_text.toLowerCase()
        if (this.originCounts[origin]) {
          this.originCounts[origin]++
        } else {
          this.originCounts[origin] = 1
        }
      })
    },
    processGenderData() {
      this.genderQuestionsData.answers.forEach((answer) => {
        if (this.genderCounts[answer.answer_text]) {
          this.genderCounts[answer.answer_text]++
        } else {
          this.genderCounts[answer.answer_text] = 1
        }
      })
    },

    processStayData() {
      this.averageLengthOfStayQuestionsData.answers.forEach((answer) => {
        if (this.stayCounts[answer.answer_text]) {
          this.stayCounts[answer.answer_text]++
        } else {
          this.stayCounts[answer.answer_text] = 1
        }
      })
    },
    processAccommodationData() {
      const accommodationCounts = {
        Resort: 0,
        Hotel: 0,
        Pousada: 0,
        Hostel: 0,
        'Casa própria': 0,
        'Casa de amigos': 0,
        Camping: 0,
        Outro: 0,
      }

      this.accommodationPreferencesQuestionData.answers.forEach((answer) => {
        if (accommodationCounts.hasOwnProperty(answer.answer_text)) {
          accommodationCounts[answer.answer_text] += 1
        }
      })
      this.accommodationCounts = accommodationCounts
    },

    processAgeData() {
      this.ageCounts = {}
      this.ageRangeQuestionData.answers.forEach((answer) => {
        const age = answer.answer_text.toLowerCase()
        if (this.ageCounts[age]) {
          this.ageCounts[age]++
        } else {
          this.ageCounts[age] = 1
        }
      })
    },

    createAccommodationChart() {
      const ctx = document.getElementById('profile-accommodation-preference-chart').getContext('2d')

      const accommodationCounts = {
        Resort: Array(12).fill(0),
        Hotel: Array(12).fill(0),
        Pousada: Array(12).fill(0),
        Hostel: Array(12).fill(0),
        'Casa própria': Array(12).fill(0),
        'Casa de amigos': Array(12).fill(0),
        Camping: Array(12).fill(0),
        Outro: Array(12).fill(0),
      }

      this.accommodationPreferencesQuestionData.answers.forEach((answer) => {
        const answerDate = new Date(answer.answer_date)
        const month = answerDate.getMonth()
        const accommodationType = answer.answer_text
        accommodationCounts[accommodationType][month]++
      })
      const months = [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ]

      const backgroundColors = [
        '#BD516C',
        '#62AD9B',
        '#7749F8',
        '#324DDD',
        '#FFA500',
        '#FF69B4',
        '#FFD700',
      ]

      const datasets = Object.keys(accommodationCounts).map((accommodationType, index) => ({
        label: accommodationType,
        backgroundColor: backgroundColors[index],
        borderWidth: 1,
        data: accommodationCounts[accommodationType],
      }))
      // Calcular o maior valor entre todas as barras dos datasets
      let maxValue = 0
      datasets.forEach((dataset) => {
        dataset.data.forEach((value) => {
          if (value > maxValue) {
            maxValue = value
          }
        })
      })

      // Definir o suggestedMax como o maior valor mais 15
      const suggestedMax = maxValue + 1
      if (this.accommodationChart) this.accommodationChart.destroy()
      this.accommodationChart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: months,
          datasets: datasets,
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          y: {
            suggestedMin: 1,
            suggestedMax: suggestedMax,
          },
          plugins: {
            legend: { display: true },
            title: { display: false },
          },
        },
      })
    },

    createProfileGenderChart() {
      const ctx = document.getElementById('profile-gender-chart').getContext('2d')
      if (this.genderChart) this.genderChart.destroy()
      this.genderChart = new Chart(ctx, {
        type: 'pie',
        data: {
          labels: Object.keys(this.genderCounts),
          datasets: [
            {
              label: 'Gênero',
              data: Object.values(this.genderCounts),
              backgroundColor: ['#BD516C', '#62AD9B', '#324DDD'],
              hoverOffset: 4,
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            legend: { position: 'top' },
            title: { display: false, font: { size: 22 } },
          },
        },
      })
    },
    createTransportPreferenceChart() {
      const ctx = document.getElementById('profile-transport-preference-chart').getContext('2d')
      const labels = [
        'Avião',
        'MotorHome',
        'Carro próprio',
        'Carro Alugado',
        'Transporte por aplicativos',
        'Moto',
        'Ônibus fretado (excursão)',
      ]
      const data = labels.map((label) => this.transportModeCounts[label.toLowerCase()] || 0)
      if (this.transportChart) this.transportChart.destroy()
      this.transportChart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: labels,
          datasets: [
            {
              label: 'Preferências dos Modais',
              data: data,
              backgroundColor: [
                '#008000',
                '#0000FF',
                '#00FFBF',
                '#ADD8E6',
                '#FF6666',
                '#808080',
                '#808080',
              ],
              hoverOffset: 4,
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            legend: {
              position: 'top',
            },
            title: {
              display: false,
            },
          },
        },
      })
    },
    createProfileTimeChart() {
      const ctx = document.getElementById('profile-time-chart').getContext('2d')

      // Filtrar os rótulos e dados para remover aqueles com contagem zero
      const filteredLabels = []
      const filteredData = []

      const labels = ['7 dias ou mais', '4 dias', '3 dias', '2 dias', '1 dia']
      labels.forEach((label) => {
        const count = this.stayCounts[label] || 0
        if (count > 0) {
          filteredLabels.push(label)
          filteredData.push(count)
        }
      })

      const maxValue = Math.max(...filteredData)
      if (this.timeChart) this.timeChart.destroy()
      this.timeChart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: filteredLabels,
          datasets: [
            {
              data: filteredData,
              backgroundColor: '#7749F8',
              barThickness: 15,
            },
          ],
        },
        options: {
          indexAxis: 'y',
          responsive: true,
          maintainAspectRatio: true,
          plugins: {
            legend: { display: false },
            title: { display: false },
            tooltip: {
              enabled: true,
              mode: 'nearest',
              intersect: true,
              callbacks: {
                label: function (context) {
                  return `${context.dataset.data[context.dataIndex]}`
                },
              },
            },
          },
          scales: {
            x: {
              suggestedMin: 1,
              suggestedMax: maxValue + 1,
            },
          },
          interaction: {
            mode: 'nearest',
            intersect: true,
          },
        },
      })
    },

    createAgeChart() {
      const ctx = document.getElementById('profile-age-chart').getContext('2d')

      const ageCounts = {
        'de 14 a 17 anos': Array(12).fill(0),
        'de 18 a 25 anos': Array(12).fill(0),
        '26 a 35 anos': Array(12).fill(0),
        'de 36 a 50 anos': Array(12).fill(0),
        'de 51 a 65 anos': Array(12).fill(0),
        'acima de 65 anos': Array(12).fill(0),
      }

      this.ageRangeQuestionData.answers.forEach((answer) => {
        const answerDate = new Date(answer.answer_date)
        const month = answerDate.getMonth()
        const ageRange = answer.answer_text
        ageCounts[ageRange][month]++
      })

      const months = [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ]

      const backgroundColors = ['#0E312B', '#1B5249', '#2A897A', '#83B370', '#8EB562', '#99B854']

      const datasets = Object.keys(ageCounts).map((ageRange, index) => {
        const colorIndex = backgroundColors.length - index - 1 // Inverte a ordem das cores
        const backgroundColor = backgroundColors[colorIndex]
        return {
          label: ageRange,
          backgroundColor: backgroundColor,
          borderWidth: 1,
          data: ageCounts[ageRange],
          barThickness: 15,
        }
      })

      let maxValue = 0
      datasets.forEach((dataset) => {
        dataset.data.forEach((value) => {
          if (value > maxValue) {
            maxValue = value
          }
        })
      })

      const suggestedMax = maxValue + 1
      if (this.ageChart) this.ageChart.destroy()
      this.ageChart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: months,
          datasets: datasets,
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            title: {
              display: true,
              font: {
                size: 22,
              },
            },
            legend: {
              display: true,
            },
          },
          scales: {
            x: {
              grid: {
                display: false,
              },
            },
            y: {
              beginAtZero: true,
              suggestedMax: suggestedMax,
              ticks: {
                stepSize: 1,
              },
            },
          },
        },
      })
    },

    createOriginMap() {
      const answerCounts = {}
      this.stateOriginQuestionData.answers.forEach((answer) => {
        const { answer_text } = answer
        if (stateCoordinates.hasOwnProperty(answer_text)) {
          if (!answerCounts[answer_text]) {
            answerCounts[answer_text] = 0
          }
          answerCounts[answer_text] += 1
        }
      })

      const filteredLocation = []
      Object.keys(answerCounts).forEach((answer_text) => {
        if (stateCoordinates.hasOwnProperty(answer_text)) {
          const { lat, lng } = stateCoordinates[answer_text]
          filteredLocation.push([lat, lng, answerCounts[answer_text]])
        }
      })

      const center = filteredLocation.length > 0 ? filteredLocation[0] : [-37.87, 175.475]
      const zoom = 5

      if (this.originMap) {
        this.originMap.setView(center, zoom)
        this.originMap.eachLayer((layer) => {
          if (layer instanceof L.TileLayer) return
          this.originMap.removeLayer(layer)
        })
      } else {
        this.originMap = L.map('profile-origin-map').setView(center, zoom)
      }

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(this.originMap)

      L.heatLayer(filteredLocation, {
        radius: 25,
        blur: 20,
        maxZoom: 5,
        max: Math.max(...Object.values(answerCounts)), // Dynamically set the max intensity
        gradient: {
          0.1: 'blue',
          0.2: 'cyan',
          0.4: 'lime',
          0.6: 'yellow',
          0.8: 'orange',
          1: 'red',
        },
      }).addTo(this.originMap)
    },

    createFavoriteAttractionsMap() {
      const filteredLocation = []
      const questionCounts = {}
      const uniqueLocations = new Set() // Conjunto para armazenar as localizações únicas

      this.favoriteAttractionsData.forEach((question) => {
        const { question_text, answers } = question
        const answerCount = answers.length

        questionCounts[question_text] = answerCount

        answers.forEach((answer) => {
          if (favoriteAttractionFozDoIguacuCoordinates.hasOwnProperty(question_text)) {
            const { lat, lng } = favoriteAttractionFozDoIguacuCoordinates[question_text]
            const locationKey = `${lat},${lng}`

            // Adiciona ao conjunto para evitar duplicatas
            if (!uniqueLocations.has(locationKey)) {
              uniqueLocations.add(locationKey)
              filteredLocation.push({ lat, lng, question_text, locationKey })
            }
          }
        })
      })
      const center =
        filteredLocation.length > 0
          ? [filteredLocation[0].lat, filteredLocation[0].lng]
          : [-25.613658838457862, -54.59023360359129]
      const zoom = 11

      if (this.favoriteAttractionsMap) {
        this.favoriteAttractionsMap.setView(center, zoom)
        this.favoriteAttractionsMap.eachLayer((layer) => {
          if (layer instanceof L.TileLayer) return
          this.favoriteAttractionsMap.removeLayer(layer)
        })
      } else {
        this.favoriteAttractionsMap = L.map('profile-favorite-attractions-map').setView(
          center,
          zoom,
        )
      }

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(this.favoriteAttractionsMap)

      let control = L.control({ position: 'bottomleft' })

      control.onAdd = function () {
        let container = L.DomUtil.create('div')

        let info = L.DomUtil.create('div', '', container)
        info.innerHTML = `
      <div style="display: flex; flex-direction: column; background: white; border-radius: 16px; padding: 20px; width: 300px">
        <div style="display: flex; flex-direction: row; align-items: center;margin-bottom:15px">
          <img style="margin-right: 10px" src="/map3.svg" />
          <div style="display: flex; flex-direction: column">
            <span style="font-size:0.875rem; font-weight: 600; color:#37434A">Em alta</span>
            <span style="font-size:0.75rem; font-weight: 400; color:#37434A">Em torno de 200.000 visitar no período</span>
          </div>
        </div>
        <div style="display: flex; flex-direction: row; align-items: center;margin-bottom:15px">
          <img style="margin-right: 10px" src="/map2.svg" />
          <div style="display: flex; flex-direction: column">
            <span style="font-size:0.875rem; font-weight: 600; color:#37434A">Parcialmente visitado</span>
            <span style="font-size:0.75rem; font-weight: 400; color:#37434A">Em torno de 50.000 visitar no período</span>
          </div>
        </div>
        <div style="display: flex; flex-direction: row; align-items: center;margin-bottom:15px">
          <img style="margin-right: 10px" src="/map1.svg" />
          <div style="display: flex; flex-direction: column">
            <span style="font-size:0.875rem; font-weight: 600; color:#37434A">Pouco visitado</span>
            <span style="font-size:0.75rem; font-weight: 400; color:#37434A">Em torno de 10.000 visitar no período</span>
          </div>
        </div>
      </div>
    `
        return container
      }

      control.addTo(this.favoriteAttractionsMap)

      const customIcon = L.icon({
        iconUrl: '/marker-icon.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28],
        shadowUrl: '',
      })

      // Adicionando marcadores ao mapa com legendas
      filteredLocation.forEach(({ lat, lng, question_text }) => {
        let tooltipImage = ''
        if (questionCounts[question_text] <= 10000) {
          tooltipImage = 'map1.svg'
        }
        if (questionCounts[question_text] > 10000 && questionCounts[question_text] <= 50000) {
          tooltipImage = 'map2.svg'
        }
        if (questionCounts[question_text] >= 200000) {
          tooltipImage = 'map3.svg'
        }
        const marker = L.marker([lat, lng], { icon: customIcon }).addTo(this.favoriteAttractionsMap)
        const tooltipContent = `<img class="leaflet-tooltip-img" src="/${tooltipImage}"/> <div class="leaflet-tooltip-text"> <span class="leaflet-tooltip-text-title">${question_text}</span><span class="leaflet-tooltip-text-count">${questionCounts[question_text]}</span></div>`
        marker
          .bindTooltip(tooltipContent, {
            direction: 'left',
            permanent: true,
            sticky: false,
            className: 'leaflet-tooltip-own',
          })
          .openTooltip()
      })
      console.log('Mapa de atrações favoritas carregado com sucesso')
    },

    async fectchRealTime() {
      try {
        const response = await axios.get('/api/transport-modes')
        this.genderQuestionsData = response.data.genderQuestions
        this.averageLengthOfStayQuestionsData = response.data.averageLengthOfStayQuestions
        this.accommodationPreferencesQuestionData = response.data.accommodationPreferencesQuestion
        this.stateOriginQuestionData = response.data.stateOriginQuestion
        this.transportModePreferencesQuestionData = response.data.transportModePreferencesQuestion
        this.favoriteAttractionsData = response.data.favoriteAttractions
        this.$toast.add({
          severity: 'success',
          summary: 'Dados atualizados com sucesso!',
          life: 3000,
        })
      } catch (error) {}
    },
    async fectchPastTime(days) {
      try {
        const response = await axios.post('/api/transport-modes/past-data', { days })
        this.genderQuestionsData = response.data.genderQuestions
        this.averageLengthOfStayQuestionsData = response.data.averageLengthOfStayQuestions
        this.accommodationPreferencesQuestionData = response.data.accommodationPreferencesQuestion
        this.stateOriginQuestionData = response.data.stateOriginQuestion
        this.transportModePreferencesQuestionData = response.data.transportModePreferencesQuestion
        this.favoriteAttractionsData = response.data.favoriteAttractions
        this.ageRangeQuestionData = response.data.ageRangeQuestion
        this.$toast.add({
          severity: 'success',
          summary: 'Dados atualizados com sucesso!',
          life: 3000,
        })
      } catch (error) {}
    },
  },
}
</script>

<style src="./styles.scss" lang="scss"></style>
